import styled from 'styled-components';

export const MessageListRoot = styled.div`
  width: 100%;
  overflow-y: scroll;
  flex-grow: 1;
`;
